<div class="d-flex flex-wrap">
    <div *ngFor="let item of projects">
        
        <div class="flex-item clickable" style="min-width: inherit; max-width: inherit;" (click)="show(item.mnemonic)">
            <div class="card card-default grow hover-link">
                <div class="panel-heading">
                    <div class="row" style="padding: 5px; padding-left: 10px; padding-bottom: 2px;">
                        <div class="col-sm-3">

                            <div>
                                
                                <i style="font-size: 64px;" [ngClass]="item.icon" ></i>
                                
                            </div>

                        </div>
                        <div class="col-sm-9 text-muted">
                          
                            <div class="card-caption-small float-end">{{item.name}}</div>
                            <br>
                            <div [innerHtml]="item.summary" class="float-end" style="text-align: right;"></div>
                        </div>
                    </div>
                </div>
    
            </div>
        </div>
    </div>
</div>